import { styled } from '@mui/material/styles';
import { IconButton } from 'components/buttons';
import { FormContainer } from 'components/styledComponents';

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  transform: `translateX(${theme.spacing(1)})`,
  color: theme.color.danger.main,
  transition: 'color 0.2s ease',

  '&:hover': {
    color: theme.color.danger.main,
    border: `1px solid ${theme.color.danger.main}`
  },
  '&:active': {
    backgroundColor: theme.color.danger.main,
    color: theme.color.primary.contrast, // keep icon visible against red background
    border: `1px solid ${theme.color.danger.main}`
  }
}));

export const WorkWrapper = styled('div')(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.color.grey[400]}`,
  boxSizing: 'border-box',
  display: 'flex',
  [`& ${FormContainer}`]: {
    flexGrow: 1
  }
}));
